import Vue from 'vue'
import Tooltip from 'apps/legacy-components/tooltip.vue'
import rtHelps from '../../legacy-components/rt-helps.vue'
import EmailCaptureForm from '../../components/email-capture-form'

new Vue({
  el: '#mortgage-rate-table-helps',
  components: {
    rtHelps: rtHelps
  }
})

new Vue({
  el: '#advertiser-disclosure',
  components: {
    Tooltip
  }
})

if (document.getElementById('email-capture-form')) {
  new Vue({
    el: '#email-capture-form',
    components: {
      EmailCaptureForm
    }
  })
}

if (document.getElementById('tab-location')) {
  new Vue({
    el: '#tab-location',
    components: {
      EmailCaptureForm
    }
  })
}
